import { Injectable } from '@angular/core';
import { get, post, put, patch, del } from 'aws-amplify/api';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public async get(
    apiName: string,
    path: string,
    options?: {
      [key: string]: any;
    },
  ): Promise<any> {
    return (await get({ apiName, path, options }).response).body.json();
  }

  public async post(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    return (await post({ apiName, path, options }).response).body.json();
  }

  public async put(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    return (await put({ apiName, path, options }).response).body.json();
  }

  public async patch(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    return (await patch({ apiName, path, options }).response).body.json();
  }

  public async del(
    apiName: string,
    path: string,
    options?: {
      [key: string]: any;
    },
  ): Promise<void> {
    await del({ apiName, path, options }).response;
  }
}
